import { useLazyQuery, useMutation } from "@apollo/client";
import { createCheckinTemplate } from "GraphQL/mutation/checkinTemplatesMutation";
import { uploadedUrlCheckin } from "GraphQL/mutation/createTargetNew";
import {
  getSingleCheckIn,
  getTargetTitleTagDetails,
} from "GraphQL/queries/targetDetail";
import { useTargetConstants } from "Hooks/target/useTargetConstants";
import { useToast } from "Hooks/useToast";
// import { setCheckinInputData } from "Pages/Target/utils";
import { useFormattedData } from "Hooks/useFormattedData";
import {
  get,
  isString,
  map,
  uniqBy,
  omit,
  sortBy,
  isBoolean,
  isEmpty,
} from "lodash";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loggedInUserState } from "Recoil/LoggedInUserDetail/atom";
import {
  DATE_FORMAT,
  FETCH_POLICY,
  INCOMING_FORMAT,
  DATE_TO_STORE,
  DEFAULT_DAYSTOCOMPLETE,
} from "src/constants";
import { defaultAttachmentImage, getCompanyId, getUserId } from "src/utils";
import { uploadFileByUrl } from "src/utils/fileUpload";
import { getTranslationConstants } from "src/constants/translationConstants";
// import AddCheckin from "Components/AddCheckin";
import moment from "moment";
import { useCheckinTemplates } from "./useCheckinTemplates";
import { getCheckInQuestions } from "GraphQL/queries/checkin/templates";
import {
  checkinFeedbackDetailsState,
  checkinFeedbackState,
  checkinSRSDetailsState,
  checkinSRSSummeryState,
  targetDetailsState,
} from "../../recoil/Targets/atom";
import {
  authPageState,
  checkinDetailState,
  displayLinkState,
  surveySummaryState,
} from "Recoil/Checkins/atom";
import {
  getLearningSummary,
  getSkillRating,
  responseSummaryReport,
} from "GraphQL/queries/listCheckins";
import { respondedToQuestions } from "GraphQL/mutation/respondSkillRating";
import {
  getSkillRatingDetails,
  getSRSCheckinDetails,
  getSRSSDetails,
  targetLevelSkillScore,
} from "GraphQL/queries/checkin/skillRatingResponseSummery";
import { getFeedbackDetails } from "GraphQL/queries/checkin/feedbackResponseSummery";
import { CheckinFrequencyDatesList } from "GraphQL/queries/targetDetail";
import { useFormContext } from "react-hook-form";
import { isCompanyAdmin } from "src/utils/externalCoachCondition";

export const useCheckin = (
  name,
  methods,
  watchCheckinDetails = [],
  setLoader
) => {
  const [uploadImageInAdvancedOptions] = useMutation(uploadedUrlCheckin);
  const { skillsQuestionsMapping } = useTargetConstants();
  const [createCheckinTemplateData] = useMutation(createCheckinTemplate);
  const toaster = useToast();
  const { refetchCheckinLibrary } = useCheckinTemplates(methods);
  const { individualUserSearchFormat } = useFormattedData();
  const _loggedInUser = useRecoilValue(loggedInUserState);
  const translationConstants = getTranslationConstants();
  const setCheckinFeedback = useSetRecoilState(checkinFeedbackState);
  const checkinViewDetails = useRecoilValue(checkinDetailState);
  const setCheckinDetail = useSetRecoilState(checkinDetailState);
  const setSurveySummary = useSetRecoilState(surveySummaryState);
  const setSRSSummeryDetails = useSetRecoilState(checkinSRSSummeryState);
  const setSRSDetails = useSetRecoilState(checkinSRSDetailsState);
  const setFeedbackDetails = useSetRecoilState(checkinFeedbackDetailsState);
  const viewDetails = useRecoilValue(displayLinkState);
  const targetOverview = useRecoilValue(targetDetailsState);
  const setDisplayLinkState = useSetRecoilState(displayLinkState);
  const setAuthPageState = useSetRecoilState(authPageState);
  // const {
  //   watch,
  //   setValue,
  //   clearErrors,
  //   formState: { errors },
  // } = useFormContext();

  const addEditCheckinTemplate = (watchCheckinData) => {
    const checkinFormatted = setCheckinInputData(watchCheckinData, 0);
    const checkinData = omit(checkinFormatted, ["startDate", "endDate"]);
    const variables = {
      input: {
        // id: 0,
        targetCompanyId: getCompanyId(),
        createdByUserId: getUserId(),
        assignCheckInsToTarget: {
          targetCheckins: [
            {
              ...checkinData,
              isCheckinLibrary: 1,
              // templateEndDateTime: watchCheckinData.details.templateEndDateTime
            },
          ],
        },
      },
    };

    if (watchCheckinData?.details?.templateEndDateTime) {
      variables.input.assignCheckInsToTarget.targetCheckins[0].templateEndDateTime =
        watchCheckinData?.details?.templateEndDateTime;
    }

    if (isBoolean(watchCheckinData.details.isImmediate)) {
      variables.input.assignCheckInsToTarget.targetCheckins[0].isImmediate =
        watchCheckinData.details.isImmediate;
    }

    if (!get(watchCheckinData, "details.isImmediate")) {
      if (watchCheckinData?.details?.templateLaunchDay) {
        variables.input.assignCheckInsToTarget.targetCheckins[0].templateLaunchDay =
          watchCheckinData.details.templateLaunchDay;
      }
      if (watchCheckinData?.details?.templateLaunchDateTime) {
        variables.input.assignCheckInsToTarget.targetCheckins[0].templateLaunchDateTime =
          watchCheckinData.details.templateLaunchDateTime;
      }
    }

    if (get(watchCheckinData, "current.action", "") === "duplicate") {
      variables.input.assignCheckInsToTarget.targetCheckins[0].name =
        variables.input.assignCheckInsToTarget.targetCheckins[0].name +
        " Copy-" +
        moment().format(DATE_FORMAT);
      delete variables.input.assignCheckInsToTarget.targetCheckins[0].id;
    }

    createCheckinTemplateData({
      variables,
    })
      .then(() => {
        // refetchData
        refetchCheckinLibrary();
        toaster.success({ message: "Check-in template saved successfully" });
      })
      .catch((err) => {
        toaster.error({ message: translationConstants.TOAST_ERROR });
      });
  };

  const onUploadImageInLearningCheckin = ({ file, attachments, setValue }) => {
    const { watch } = methods;
    const { type } = watch(`${name}.current`);
    const documentObj = {
      key: file.name,
      fileName: file.name,
    };
    const targetCompanyId = getCompanyId();

    const variables = {
      input: {
        currentAction: "TargetInformation",
        targetCompanyId,
        createdByUserId: getUserId(),
        assignCheckInsToTarget: {
          targetCheckins: [
            {
              combinedCheckInTypes: type,
              multimediaCheckin: { s3Link: { ...documentObj } },
            },
          ],
        },
      },
    };

    uploadImageInAdvancedOptions({ variables })
      .then((res) => {
        const doc = get(
          res,
          "data.createTargetMutation_New.assignCheckInsToTarget.targetCheckins.0.multimediaCheckin.s3Link",
          {}
        );
        if (doc.uploadUrl) {
          const { __typename, ...otherKeys } = doc;
          uploadFileByUrl(doc.uploadUrl, file, () => {
            setValue(`${name}.details.multimedia.dragLoader`, false);
            setValue(`${name}.details.multimedia.attachments`, [
              {
                ...otherKeys,
                name: doc.fileName,
                type: file.type,
              },
            ]);
          });
        }
        setValue(`${name}.dragLoader`, false);
      })
      .catch((error) => {
        setValue(`${name}.details.multimedia.dragLoader`, false);
      })
      .finally(() => setValue(`${name}.details.uploadDocumentLoader`, false));
  };

  const onUploadImageInSurveyCheckin = ({ file, attachments, setValue }) => {
    const { watch } = methods;
    const { type } = watch(`${name}.current`);
    const { checkInId } = watch(`${name}.details`);
    const watchMultimedia = watch(`${name}.details.multimedia`);

    const result = [...(watchMultimedia?.attachments || [])].map((res) => {
      if (typeof res !== "string") {
        delete res?.type;
        delete res?.name;
        const obj = {
          bucket: res?.bucket,
          fileName: res?.fileName,
          key: res?.key,
          region: res?.region,
          uploadUrl: res?.uploadUrl,
          url: res?.url,
        };
        // return { s3Link: obj };
      }
    });

    const documentObj = result?.filter((y) => y !== undefined);
    documentObj.push({
      s3Link: {
        key: file.name,
        fileName: file.name,
      },
    });

    const targetCompanyId = getCompanyId();

    const variables = {
      input: {
        currentAction: "TargetInformation",
        targetCompanyId,
        createdByUserId: getUserId(),
        assignCheckInsToTarget: {
          targetCheckins: [
            {
              combinedCheckInTypes: type,
              surveyMultimediaCheckin: documentObj,
            },
          ],
        },
      },
    };

    uploadImageInAdvancedOptions({ variables })
      .then((res) => {
        const { surveyMultimediaCheckin } =
          res?.data?.createTargetMutation_New?.assignCheckInsToTarget
            ?.targetCheckins?.[0];
        // const doc = get(
        //   res,
        //   "data.createTargetMutation_New.assignCheckInsToTarget.targetCheckins.0.surveyMultimediaCheckin.0.s3Link",
        //   []
        // );
        const docList = surveyMultimediaCheckin.map((res) => {
          return res?.s3Link;
        });
        docList.map((doc) => {
          if (doc.uploadUrl) {
            const { __typename, ...otherKeys } = doc;
            uploadFileByUrl(doc.uploadUrl, file, () => {
              setValue(`${name}.details.multimedia.dragLoader`, false);
              setValue(`${name}.details.multimedia.attachments`, [
                ...(watchMultimedia?.attachments || []),
                {
                  ...otherKeys,
                  isNew: checkInId && !isEmpty(checkInId) ? false : doc?.isNew,
                  name: doc.fileName,
                  type: file.type,
                },
              ]);
            });
          }
          setValue(`${name}.dragLoader`, false);
          return doc;
        });
      })
      .catch((error) => {
        setValue(`${name}.details.multimedia.dragLoader`, false);
      })
      .finally(() => setValue(`${name}.details.uploadDocumentLoader`, false));
  };

  const [getCheckinFeedbackQuestions, { loading: singleCheckinLoaders }] =
    useLazyQuery(getCheckInQuestions, {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        setCheckinFeedback(data.getDataForFeedbackCheckin);
      },
    });

  const [getSRSCheckin, { loading: SRSCheckinLoader }] = useLazyQuery(
    getSkillRatingDetails,
    {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        setSRSDetails(data.getSRSCheckinDetails);
      },
    }
  );

  const [SRSCheckinDetails, { loading: SRSCheckinDetailsLoader }] =
    useLazyQuery(getSRSCheckinDetails, {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onError: (err) => {
        // setLoader((res) => ({ ...res, learningLoader: false }));
        setSRSDetails((res) => {
          return { ...res, loading: false };
        });
        if (
          err.message === "You are not authorized to view check-in details."
        ) {
          setAuthPageState(true);
        }
      },
      onCompleted: (data) => {
        setSRSDetails((res) => {
          return { ...res, ...data.getSRSCheckinDetails, loading: false };
        });
      },
    });

  const [getTargetlevelSkillScore, { loading: targetSkillScore }] =
    useLazyQuery(targetLevelSkillScore, {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        const details = data.getSRSCheckinDetails;
        setSRSDetails((res) => {
          return {
            ...res,
            ...details,
            loading: false,
            frequencies: !isEmpty(details?.frequencies)
              ? details?.frequencies
              : res?.frequencies,
          };
        });
      },
    });

  const [FeedbackCheckinDetails, { loading: FeedbackCheckinLoader }] =
    useLazyQuery(getFeedbackDetails, {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        const checkin = get(data, "getCheckIn");
        const { setValue } = { ...methods };
        setCheckinDetail({ ...checkinViewDetails, ...checkin });
        const checkinTarget = get(checkin, "usercheckin.items", []).filter(
          (item) => item.id === get(watchCheckinDetails, "frequency.id", "")
        );
        const user = get(checkin, "usersForCheckin.items", []).filter(
          (item) => item.userid === getUserId()
        );
        const processChekin = {
          ...checkin,
          multimedia: {
            attachment: [
              {
                fileName: get(checkin, "multimediaCheckin.s3Link.fileName", ""),
              },
            ],
          },
          defaultImage: defaultAttachmentImage(
            get(checkinTarget, "0.responseDocument.fileName", ""),
            get(checkinTarget, "0.attachmentLink.link")
          ),
        };
        setValue(`${name}.openLearning`, true);
        setValue(`${name}.details`, processChekin);
        setValue(`${name}.description`, get(checkin, "description", ""));
        setValue(`${name}.details.checkinTargetFrequency`, checkinTarget);
        setValue(`${name}.learningUser`, get(user, "0.user", ""));
        setFeedbackDetails(checkin);
      },
    });

  const [targetDetails] = useLazyQuery(getTargetTitleTagDetails, {
    onCompleted: (data) => {
      const target = get(data, "getTarget");

      setSRSDetails((res) => {
        return { ...res, target };
      });
    },
  });

  const handleSurveyLink = (checkin) => {
    // const { surveyLinks, surveyMultimediaCheckin } = checkin;
    const data = [];
    if (checkin?.surveyLinks?.length > 0) {
      checkin?.surveyLinks.map((item) => {
        data.push(item.link);
      });
    }
    if (checkin?.surveyMultimediaCheckin?.length > 0) {
      checkin?.surveyMultimediaCheckin?.map((res) => {
        data.push(res.s3Link);
      });
    }
    return data;
  };

  const [getSingleCheckinData, { loading: singleCheckinLoader }] = useLazyQuery(
    getSingleCheckIn,
    {
      fetchPolicy: FETCH_POLICY.networkOnly,
      // nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: async (data) => {
        const checkin = get(data, "getCheckIn");
        if (get(checkin, "linkCheckin.image")) {
          const details_link = { ...get(checkin, "linkCheckin", {}) };
          delete details_link.link;
          await setDisplayLinkState({
            url: get(checkin, "linkCheckin.link"),
            ...details_link,
          });
        }
        const { setValue, watch } = { ...methods };
        const targetUsers = watch("assignPeople");
        const { startDate } = watch("details");
        const { current } = watch(name);
        // const watchSkills = watch("details.skillsAndStrengths");
        // const { action, targetMode } = watch(`${name}.current`);
        // TODO add status other then active and overdue _loggedInUser
        const attachment = get(checkin, "linkCheckin.link")
          ? [get(checkin, "linkCheckin.link")]
          : get(checkin, "checkInType") === "LEARNING"
          ? [get(checkin, "multimediaCheckin.s3Link")]
          : handleSurveyLink(checkin);
        const skills = get(checkin, "skills");

        const checkinCoachId = get(checkin, "checkinCoachId");
        const creator = individualUserSearchFormat([
          checkin?.isCheckinLibrary ? _loggedInUser : checkin?.createdBy,
        ]).map((res) => ({ ...res, selected: true }));
        // .map(
        //   (res) => {
        //     return {
        //       ...res,
        //       selected: false,
        //       disabled: false,
        //     };
        //   }
        // );

        const selectedCoachee = [
          ...creator,
          ...get(targetUsers, "userListData", []),
        ]
          .filter(
            (u) => u.userInGroup || u.selected
            // && u.id !== creator[0].id
          )

          .map((r) => {
            return {
              ...r,
              selected: false,
              userInGroup: false,
              disabled: false,
            };
          });

        const selectedCoach = [
          ...creator,
          ...get(targetUsers, "coachListData", []),
        ]
          .filter((u) => u.selected)
          .map((r) => {
            return {
              ...r,
              selected: false,
              isPrimaryCoach: false,
              disabled: false,
            };
          });

        const allUsers = uniqBy([...selectedCoachee, ...selectedCoach], "id");

        let editUserListData =
          get(checkin, "checkInType") === "SKILLRATING"
            ? get(checkin, "allCheckinRatees", []).filter(
                (res) => !res?.isSoftDelete
              )
            : map(
                get(checkin, "usersForCheckin.items", []).filter(
                  (res) => !res?.isSoftDelete
                ),
                "user"
              );
        editUserListData = individualUserSearchFormat(editUserListData);
        // .filter(
        //   u => u.id !== checkinCoachId
        // );

        let editCoachListData =
          get(checkin, "checkInType") === "SKILLRATING"
            ? get(checkin, "allCheckinRaters", [])
            : get(checkin, "allCheckinViewers", []);

        editCoachListData = individualUserSearchFormat(
          editCoachListData.filter((res) => !res?.isSoftDelete)
        ).filter((u) => !u.isAddedFromBE);
        const condition =
          isCompanyAdmin() ||
          [checkin?.createdBy?.id, checkin?.checkinCoachId].includes(
            getUserId()
          );
        let editViewerListData =
          get(checkin, "checkInType") === "SKILLRATING"
            ? get(checkin, "allCheckinViewers", []).filter(
                (res) => !res?.isSoftDelete
              )
            : [];

        editViewerListData = individualUserSearchFormat(
          editViewerListData
        ).filter((u) => !u.isAddedFromBE);
        const mappedListData = uniqBy(allUsers, "id").reduce((result, item) => {
          if (map(editUserListData, "id").includes(item.id)) {
            result.push({
              ...item,
              selected: true,
              //disabled: false
              disabled: !condition,
            });
          } else {
            result.push(item);
          }
          return result;
        }, []);

        const mappedCoachData = uniqBy([...allUsers], "id").reduce(
          (result, item) => {
            if (map(editCoachListData, "id").includes(item.id)) {
              result.push({
                ...item,
                selected: true,
                //disabled: creator[0].id !== item.id ? false : true,
                disabled: condition ? false : true,
                isPrimaryCoach: item.id === checkinCoachId,
              });
            } else {
              result.push({
                ...item,
                isPrimaryCoach: item.id === checkinCoachId,
              });
            }
            return result;
          },
          []
        );

        const mappedViewerData = uniqBy([...allUsers], "id").reduce(
          (result, item) => {
            if (map(editViewerListData, "id").includes(item.id)) {
              result.push({
                ...item,
                selected: true,
                //disabled: creator[0].id === item.id ? true : false
                disabled: !condition,
                // isPrimaryCoach: item.id === checkinCoachId
              });
            } else {
              result.push(item);
              // ({
              //   ...item,
              //   // isPrimaryCoach: item.id === checkinCoachId
              // });
            }
            return result;
          },
          []
        );

        const questionOptions = (
          get(checkin, "surveyCheckin.surveycheckin", []) || []
        ).map((item) => {
          return {
            type: item.questionType,
            question: item.question,
            answer: item.answer,
            options: item.options,
            disableAddOption: false,
          };
        });
        let launchDate = "";
        if (typeof get(checkin, "isImmediate") === "boolean") {
          // moment('2010-10-20').isAfter('2010-10-19'); // true
          // startdate > today? startDate
          const date = moment(startDate).isAfter(moment())
            ? startDate
            : moment().startOf("day").format(INCOMING_FORMAT);
          if (get(checkin, "isImmediate")) {
            launchDate = date;
          } else {
            launchDate = moment(date)
              .add(+get(checkin, "templateLaunchDay", 1), "day")
              .format(INCOMING_FORMAT);
          }
        }

        const frequencyRepeatMonthly = {};
        if (
          checkin?.frequencyRepeatMonthly?.toggleDaysOfMonth === "dayofMonth"
        ) {
          frequencyRepeatMonthly.dayofMonth = get(
            checkin?.frequencyRepeatMonthly?.dayofMonth
          );
        } else {
          frequencyRepeatMonthly.dayOfWeekOccurrence = get(
            checkin?.frequencyRepeatMonthly?.dayOfWeekOccurrence
          );
          frequencyRepeatMonthly.dayOfWeek = get(
            checkin?.frequencyRepeatMonthly?.dayOfWeek
          );
        }
        if (name) {
          setValue(`${name}.current`, { ...current, checkinMode: "edit" });
          setValue(`${name}.details`, {
            checkInId: get(checkin, "id", ""),
            checkinFrequencyDates: get(checkin, "checkinFrequencyDates", ""),
            createdBy: get(checkin, "createdBy", ""),
            title: get(checkin, "name", ""),
            launchDate: launchDate ? launchDate : get(checkin, "startDate", ""),
            dueDate: get(checkin, "endDate", ""),
            endDate: get(checkin, "endDate", ""),
            startDate: get(checkin, "startDate", ""),
            daysToComplete: checkin?.daysToComplete || DEFAULT_DAYSTOCOMPLETE,
            templateLaunchDateTime: get(checkin, "templateLaunchDateTime", ""),
            templateEndDateTime: get(checkin, "templateEndDateTime", ""),
            launchTime: get(checkin, "launchTime", ""),
            dueTime: get(checkin, "dueTime", ""),
            isImmediate: get(checkin, "isImmediate"),
            templateLaunchDay: get(checkin, "templateLaunchDay", 1),
            frequency: get(checkin, "scheduleFrequency", "None") || "None",
            requiredAttachment: get(checkin, "isUploadResponse", false),
            requiredComment: get(checkin, "isCommentResponse", false),
            description: get(checkin, "description", "<p></p>") || "<p></p>",
            isTestSurvey: get(checkin, "isTestSurvey", false),
            frequencyRepeatDays: checkin?.frequencyRepeatDays,
            frequencyRepeatonDate: get(checkin, "frequencyRepeatonDate", ""),
            isWeekend: get(checkin, "isWeekend", false),
            weekDays: get(checkin, "weekDays", []),
            frequencyRepeatMonthly,
            createFrequency: {
              frequency: get(checkin, "scheduleFrequency", "None"),
              frequencyRepeatonDate: get(checkin, "frequencyRepeatonDate", ""),
              frequencyRepeatMonthly: {
                dayofMonth: checkin?.frequencyRepeatMonthly?.dayofMonth,
                dayOfWeekOccurrence:
                  checkin?.frequencyRepeatMonthly?.dayOfWeekOccurrence,
                dayOfWeek: checkin?.frequencyRepeatMonthly?.dayOfWeek,
                toggleDaysOfMonth:
                  checkin?.frequencyRepeatMonthly?.dayofMonth === 0
                    ? "dayOfWeekOccurrence"
                    : "dayofMonth",
              },
            },
            isAnonymousResponses: get(
              checkin,
              "surveyCheckin.isanonymous",
              false
            ),
            multimedia: {
              dragLoader: false,
              dragAndDrop: {},
              pasteLink: "",
              attachments: attachment,
            },
            skills,
          });
          setValue(`${name}.assignPeople`, {
            searchText: { coachee: "", coach: "" },
            userListData: mappedListData,
            userGroupData: [],
            coachListData: mappedCoachData,
            viewerListData: mappedViewerData,
          });

          setValue(`${name}.questions`, {
            addQuestionMode: "",
            createQuestion: {
              type: "None",
              question: "",
              answer: [],
              options: [""],
              disableAddOption: false,
            },
            questionsList: questionOptions,
          });
        }
      },
    }
  );

  const [getCheckinOverview, { loading: checkinOverviewLoader }] = useLazyQuery(
    getSingleCheckIn,
    {
      fetchPolicy: FETCH_POLICY.networkOnly,
      onCompleted: async (data) => {
        const checkin = get(data, "getCheckIn");
        if (get(checkin, "linkCheckin.image")) {
          const details_link = { ...get(checkin, "linkCheckin", {}) };
          delete details_link.link;
          await setDisplayLinkState({
            url: get(checkin, "linkCheckin.link"),
            ...details_link,
          });
        }
        setCheckinDetail(checkin);
      },
    }
  );

  const [getSurveyResponseSummaryReport, { loading: responseSummaryLoader }] =
    useLazyQuery(responseSummaryReport, {
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        setSurveySummary(get(data, "responseSummaryReport", []));
      },
    });

  const [getLearningSummaryDetails, { loading: learningSummaryLoader }] =
    useLazyQuery(getLearningSummary, {
      fetchPolicy: FETCH_POLICY.noCache,
      onCompleted: (data) => {
        const checkin = get(data, "getCheckIn");
        const { setValue } = { ...methods };
        setCheckinDetail({ ...checkinViewDetails, ...checkin });
        const checkinTarget = get(checkin, "usercheckin.items", []).filter(
          (item) => item.id === get(watchCheckinDetails, "frequency.id", "")
        );
        const user = get(checkin, "usersForCheckin.items", []).filter(
          (item) => item.user.id === getUserId()
        );

        const processChekin = {
          ...checkin,
          multimedia: {
            attachment: [
              {
                fileName: get(checkin, "multimediaCheckin.s3Link.fileName", ""),
              },
            ],
          },
          surveyMultimediaCheckin: {
            attachments: get(checkin, "surveyMultimediaCheckin", [])?.map(
              (item) => {
                return item?.s3Link;
              }
            ),
          },
          defaultImage: defaultAttachmentImage(
            get(checkinTarget, "0.responseDocument.fileName", ""),
            get(checkinTarget, "0.attachmentLink.link")
          ),
        };
        setValue(`${name}.openLearning`, true);
        setValue(`${name}.details`, processChekin);
        setValue(`${name}.description`, get(checkin, "description", ""));
        setValue(`${name}.details.checkinTargetFrequency`, checkinTarget);
        setValue(`${name}.current`, {
          current: {
            type: "LEARNING",
          },
        });
        setValue(`${name}.learningUser`, get(user, "0.user", ""));
      },
    });

  const processSkillData = (data) => {
    let skillCompletedNo = 0;
    const updatedValues = [...data].map((value) => {
      let list = { ...value };
      let skillCompleted = true;
      let userSkillCompleted = 0;

      const newSkill = { ...list?.skillRatingResponse };
      const updatedSkill = list?.skillRatingResponse?.skills.map(
        (skillResult) => {
          let skill = { ...skillResult };
          if (skill?.status !== "COMPLETED") {
            skillCompleted = false;
            newSkill.allSkillCompleted = false;
          }
          if (skillCompleted) {
            newSkill.allSkillCompleted = true;
          }
          if (skill?.status === "COMPLETED") {
            newSkill.userSkillCompleted = ++userSkillCompleted;
          }
          newSkill.skillNo = newSkill?.skills.length;
          skill?.definitions.forEach((definition, definitionIndex) => {
            if (definition?.frequency) {
              skill.skillsCompleted = definitionIndex + 1;
            }
          });
          return skill;
        }
      );
      if (list?.status === "COMPLETED") {
        ++skillCompletedNo;
      }
      return {
        ...list,
        skillRatingResponse: { ...newSkill, skills: updatedSkill },
      };
    });
    return { skills: [...updatedValues], skillCompletedNo };
  };

  const [getSkillRatingRespondDetails, { loading: skillRatingLoader }] =
    useLazyQuery(getSkillRating, {
      fetchPolicy: FETCH_POLICY.noCache,
      onCompleted: (data) => {
        const { setValue, watch } = { ...methods };
        const details = watch({ name });
        const processSkill = processSkillData([
          ...get(data, "getRateesToRate.rateesToRate", []),
        ]);
        const sortSkill = processSkill.skills.sort((a, b) =>
          b.status.localeCompare(a.status)
        );
        setValue(`${name}.details`, sortSkill || []);
        setValue(`${name}.skillModal`, {
          rateeId:
            get(details, "respondCheckin.selectedRatee.ratee.userid", false) ||
            get(data, "getRateesToRate.rateesToRate.0.ratee.userid", ""),
          userCheckinId: get(
            details,
            "respondCheckin.userCheckinDetails.0.id",
            ""
          ),
        });
        setValue(`${name}.skillLoader`, false);
        setValue(`${name}.dashboardLoader`, false);
        setValue(
          `${name}.details.skillCompletedNo`,
          get(processSkill, "skillCompletedNo", 0)
        );
      },
    });

  const [skillRatingRespondToQuestion, { loading: skillRatingRespondLoader }] =
    useMutation(respondedToQuestions);

  const removeValidationCondition = (type) =>
    ["Company", "Realignment"].includes(type);

  const getDateTime = (time, date) => {
    const updated = moment(date).format(DATE_TO_STORE);
    if (time) {
      const hr = moment(time).hour();
      const min = moment(time).minute();
      return moment(updated).add(hr, "h").add(min, "m").format(INCOMING_FORMAT);
    }
    return moment(updated).format(INCOMING_FORMAT);
  };

  const setCheckinInputData = (data, targetId, isTemplate) => {
    const description = get(data, "details.description");
    const checkinId = get(data, "current.id");
    const checkInStatus = get(data, "current.checkInStatus", "");
    const isClone = data?.current?.isTemplate || false;
    const clonedFromCheckinId = (isClone && data?.details?.checkInId) || null;
    let startDate = get(data, "details.launchDate", "");
    // getDateTime(
    //   get(data, "details.launchTime", ""),
    //   get(data, "details.launchDate", "")
    // );
    let endDate = getDateTime(
      get(data, "details.dueTime") || get(data, "details.launchTime"),
      get(data, "details.dueDate")
    );
    startDate = startDate !== "Invalid date" ? startDate : null;

    endDate = endDate !== "Invalid date" ? endDate : "";

    const userListData = get(data, "assignPeople.userListData", [])
      .filter(({ selected }) => selected)
      .map(({ id }) => {
        return {
          isSelected: true,
          userid: id,
        };
      });

    const coachListData = get(data, "assignPeople.coachListData", [])
      .filter(({ selected }) => selected)
      .map(({ id }) => {
        return {
          isSelected: true,
          userid: id,
        };
      });

    const checkinCoach = get(data, "assignPeople.coachListData", []).find(
      (u) => u.isPrimaryCoach
    );
    const multimediaCheckin = (
      (!isString(data?.details?.multimedia?.attachments) &&
        get(data, "details.multimedia.attachments", [])) ||
      []
    )
      .filter((item) => !isString(item))
      .map((item) => {
        const data = omit(item, ["name", "type", "__typename"]);
        return data;
      });

    let linkCheckin = (
      (!isString(data?.details?.multimedia?.attachments) &&
        get(data, "details.multimedia.attachments", [])) ||
      []
    )
      .filter((item) => isString(item))
      .map((res) => {
        let details = {
          ...(!isEmpty(data?.viewLink) ? data?.viewLink : viewDetails),
        };
        details = omit(details, ["url", "__typename"]);
        if (!details?.image) {
          delete details.image;
        }
        return {
          link: res,
          ...details,
        };
      });
    linkCheckin = linkCheckin[0];

    if (!isEmpty(linkCheckin) && linkCheckin.hasOwnProperty("loading")) {
      delete linkCheckin.loading;
    }

    const surveyCheckin = (get(data, "questions.questionsList", []) || []).map(
      (item) => {
        return {
          answer: item.answer,
          options: item.options,
          question: item.question,
          questionType: item.type ? item.type : item.questionType,
        };
      }
    );

    const skills = (get(data, "details.skills", []) || []).map((item) => {
      return { definitions: [], name: item.name };
    });

    const frequencyRepeatMonthly = {};
    frequencyRepeatMonthly.dayofMonth = get(
      data,
      "details.createFrequency.frequencyRepeatMonthly.dayofMonth"
    );
    frequencyRepeatMonthly.dayOfWeekOccurrence = get(
      data,
      "details.createFrequency.frequencyRepeatMonthly.dayOfWeekOccurrence"
    );

    frequencyRepeatMonthly.dayOfWeek = get(
      data,
      "details.createFrequency.frequencyRepeatMonthly.dayOfWeek"
    );

    const weekData = data?.details?.createFrequency?.weekDays;
    const weekDayWithoutTypename =
      weekData?.length > 0 &&
      weekData?.map((result) => {
        const res = { ...result };
        delete res.__typename;
        return res;
      });
    let checkin = {
      ...(checkinId && { id: checkinId }),
      ...(!isTemplate && { startDate }),
      ...(endDate && { endDate }),
      ...(get(checkinCoach, "id", "") && {
        checkinCoachId: get(checkinCoach, "id", ""),
      }),
      isClone,
      clonedFromCheckinId,
      // ...(checkInStatus && { checkInStatus }),
      checkInType: get(data, "current.type"),
      weekDays: weekDayWithoutTypename || [], //when select weekly
      isWeekend: get(data, "details.createFrequency.isWeekend"), //when select daily
      frequencyRepeatDays: data?.details?.createFrequency?.frequencyRepeatDays
        ? data?.details?.createFrequency?.frequencyRepeatDays
        : data?.details?.frequencyRepeatDays,
      frequencyRepeatonDate:
        data?.details?.createFrequency?.frequencyRepeatonDate !== "Invalid date"
          ? data?.details?.createFrequency?.frequencyRepeatonDate ||
            data?.details?.frequencyRepeatonDate
          : null,
      frequencyRepeatMonthly,
      name: get(data, "details.title"),
      description: get(data, "details.description"),
      currentDateTime: moment().format(INCOMING_FORMAT),
      daysToComplete: data?.details?.daysToComplete
        ? data?.details?.daysToComplete
        : DEFAULT_DAYSTOCOMPLETE,
      scheduleFrequency:
        get(data, "details.frequency") !== "None"
          ? get(data, "details.frequency")
          : get(data, "details.createFrequency.frequency") !== "None"
          ? get(data, "details.createFrequency.frequency")
          : null,
      checkInTargetId: targetId,
      isCheckinLibrary: 0,
      ...(get(data, "details.launchTime", "") && {
        launchTime: get(data, "details.launchTime", ""),
      }),
      ...(get(data, "details.dueTime", "") && {
        dueTime: get(data, "details.dueTime", ""),
      }),
    };

    // REQUESTFEEDBACK
    if (get(data, "current.type") === "REQUESTFEEDBACK") {
      let surveyLinks = (get(data, "details.multimedia.attachments", []) || [])
        .filter((item) => isString(item))
        .map((res) => {
          let details = {
            ...(!isEmpty(data?.viewLink) ? data?.viewLink : viewDetails),
          };
          details = omit(details, ["url", "__typename"]);
          if (!details?.image) {
            delete details.image;
          }
          return {
            link: res,
            ...details,
          };
        });
      surveyLinks = surveyLinks;
      if (!isEmpty(surveyLinks) && surveyLinks.hasOwnProperty("loading")) {
        delete surveyLinks.loading;
      }
      checkin = {
        ...(checkinId && { id: checkinId }),
        name: get(data, "details.title"),
        description: get(data, "details.description"),
        checkInType: get(data, "current.type"),
        checkInTargetId: targetId,
        startDate: moment(get(data, "details.startDate")).format(
          INCOMING_FORMAT
        ),
        endDate: moment(get(data, "details.endDate")).format(INCOMING_FORMAT),
        isCheckinLibrary: 0,
        surveyCheckin: {
          surveycheckin: surveyCheckin,
        },
        // ...(!isEmpty(multimediaCheckin) && {
        //   multimediaCheckin: { s3Link: multimediaCheckin[0] },
        // }),
        ...(!isEmpty(surveyLinks) && { surveyLinks }),
        ...(!isEmpty(multimediaCheckin) && {
          surveyMultimediaCheckin: multimediaCheckin.map((res) => ({
            s3Link: res,
          })),
        }),
        isUploadResponse: get(data, "details.requiredAttachment", false),
        assignUserToCheckin: { individualUsers: userListData },
        assignViewers: coachListData,
      };
    }

    if (get(data, "current.type") === "LEARNING") {
      checkin = {
        ...checkin,
        ...(!isEmpty(linkCheckin) && { linkCheckin }),
        ...(!isEmpty(multimediaCheckin) && {
          multimediaCheckin: { s3Link: multimediaCheckin[0] },
        }),
        isUploadResponse: get(data, "details.requiredAttachment", false),
        isCommentResponse: get(data, "details.requiredComment", false),
        assignUserToCheckin: { individualUsers: userListData },
        assignViewers: coachListData,
      };
    }

    if (get(data, "current.type") === "SURVEY") {
      let surveyLinks = (get(data, "details.multimedia.attachments", []) || [])
        .filter((item) => isString(item))
        .map((res) => {
          let details = {
            ...(!isEmpty(data?.viewLink) ? data?.viewLink : viewDetails),
          };
          details = omit(details, ["url", "__typename"]);
          if (!details?.image) {
            delete details.image;
          }
          return {
            link: res,
            ...details,
          };
        });
      surveyLinks = surveyLinks;
      if (!isEmpty(surveyLinks) && surveyLinks.hasOwnProperty("loading")) {
        delete surveyLinks.loading;
      }
      checkin = {
        ...checkin,
        ...(!isEmpty(surveyLinks) && { surveyLinks }),
        ...(!isEmpty(multimediaCheckin) && {
          surveyMultimediaCheckin: multimediaCheckin.map((res) => ({
            s3Link: res,
          })),
        }),
        surveyCheckin: {
          surveycheckin: surveyCheckin,
          isanonymous: get(data, "details.isAnonymousResponses"),
        },
        isTestSurvey: get(data, "details.isTestSurvey"),
        assignUserToCheckin: { individualUsers: userListData },
        assignViewers: coachListData,
      };
    }

    if (get(data, "current.type") === "SKILLRATING") {
      const viewerListData = get(data, "assignPeople.viewerListData", [])
        .filter(({ selected }) => selected)
        .map(({ id }) => {
          return {
            isSelected: true,
            userid: id,
          };
        });
      checkin = {
        ...checkin,
        skills,
        assignRatees: userListData,
        assignRaters: coachListData,
        assignViewers: viewerListData,
      };
    }

    if (isTemplate) {
      if (data?.details?.templateEndDateTime) {
        checkin = {
          ...checkin,
          ...(!isEmpty(multimediaCheckin) && {
            surveyMultimediaCheckin: multimediaCheckin.map((res) => ({
              s3Link: res,
            })),
          }),
          templateEndDateTime: data?.details?.templateEndDateTime,
        };
      }

      if (isBoolean(data.details.isImmediate)) {
        checkin = {
          ...checkin,
          isImmediate: data?.details?.isImmediate,
        };
      }

      if (!data?.details?.isImmediate) {
        if (data?.details?.templateLaunchDay) {
          checkin = {
            ...checkin,
            templateLaunchDay: data?.details?.templateLaunchDay,
          };
        }
        if (data?.details?.templateLaunchDateTime) {
          checkin = {
            ...checkin,
            templateLaunchDateTime: data?.details?.templateLaunchDateTime,
          };
        }
      }

      if (description === "<p></p>") {
        return {
          id: data?.current?.id,
          name: data?.details?.title,
          checkInType: data?.current?.type,
        };
      } else {
        return checkin;
      }
    }

    // If description is empty set not edited data
    if (description === "<p></p>") {
      const checkinObj = {
        // ...checkin,
        id: get(data, "current.id"),
        name: get(data, "details.title"),
        checkInType: get(data, "current.type"),
      };
      // delete checkinObj.id;
      return checkinObj;
    } else {
      return checkin;
    }
  };

  const setAddCheckinVariable = (data, targetId) => {
    const targetCheckins = setCheckinInputData(data, targetId);

    return {
      input: {
        id: targetId,
        targetCompanyId: getCompanyId(),
        createdByUserId: getUserId(),
        currentAction: "AddCheckin",
        isTargetPublished:
          targetOverview?.targetStatus === "DRAFT" ? false : true,
        assignCheckInsToTarget: { targetCheckins: [targetCheckins] },
      },
    };
  };

  // const { details, checkin, assignPeople } = watch();

  const [getCheckinFrequencyDate] = useLazyQuery(CheckinFrequencyDatesList, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onCompleted: async (data) => {
      if (data?.checkinFrequencyDatesList?.length) {
        setValue(
          "checkin.createCheckin.details.checkinFrequencyDates",
          data?.checkinFrequencyDatesList
        );
      }
    },
    onError: (err) => {
      console.log(err);
      toaster.error({ message: "Something went wrong" });
    },
  });

  return {
    onUploadImageInLearningCheckin,
    onUploadImageInSurveyCheckin,
    singleCheckinLoader,
    getSingleCheckinData,
    addEditCheckinTemplate,
    getCheckinFeedbackQuestions,
    getCheckinOverview,
    checkinOverviewLoader,
    getLearningSummaryDetails,
    learningSummaryLoader,
    getSurveyResponseSummaryReport,
    responseSummaryLoader,
    getSkillRatingRespondDetails,
    skillRatingLoader,
    skillRatingRespondToQuestion,
    skillRatingRespondLoader,
    removeValidationCondition,
    getSRSCheckin,
    SRSCheckinLoader,
    SRSCheckinDetails,
    SRSCheckinDetailsLoader,
    getTargetlevelSkillScore,
    targetSkillScore,
    targetDetails,
    FeedbackCheckinDetails,
    FeedbackCheckinLoader,
    setCheckinInputData,
    setAddCheckinVariable,
    handleSurveyLink,
    processSkillData,
    getCheckinFrequencyDate,
  };
};
